import { type ReactNode } from "react";

/**
 * Mode unique : dark.
 * On garde le Provider et useTheme pour compatibilité avec les imports existants,
 * mais ils sont des no-op.
 */
export function ThemeProvider({ children }: { children: ReactNode }) {
  return <>{children}</>;
}
